



















































import CFMDialog from '@/scripts/CFMDialog'
import {Component, Prop} from 'vue-property-decorator';
import {required} from 'vuelidate/lib/validators';
import moment from 'moment';

import { mixinz } from '@/scripts/global/mixinz';
import * as dateFormat from '@/helpers/dateFormat';
import * as blockui from '@/helpers/block-ui'

import {CFMDTOFreeze} from '@/scripts/services/ClientApiAuto'

/** Sunucu ayni kurali dakika hassasiyetinde uyguluyor: o dakika icinde baslatmak gecmis sayilmaz. */
const startOfCurrentMinute = () => moment().startOf('minute');

/** Duzenlenecek donem; listede tarihler zaten Date'e cevrilmis halde. */
export interface FreezeEditTarget {
    Id: number;
    StartDate: Date;
    EndDate: Date;
    Description?: string | null;
}

interface FreezeDraft {
    StartDate: string | null;
    EndDate: string | null;
    Description: string;
}

@Component<FreezeDialog>({
    mixins: [mixinz],
    validations() {
        return {
            freeze: {
                StartDate: {required},
                EndDate: {
                    required,
                    afterStart(this: FreezeDialog, value: string | null) {
                        const start = this.parseDisplay(this.freeze.StartDate);
                        const end = this.parseDisplay(value);
                        return !start.isValid() || !end.isValid() || end.isAfter(start);
                    },
                },
            },
        };
    },
})
export default class FreezeDialog extends CFMDialog {
    /** Bos ise yeni donem baslatilir; doluysa o donem duzenlenir. */
    @Prop({default: null})
    target!: FreezeEditTarget | null;

    /** Sunucudaki kolon siniri (Work.Freeze.Description). */
    readonly descriptionMaxLength = 500;

    freeze: FreezeDraft = {StartDate: null, EndDate: null, Description: ''};

    get isUpdate() {
        return !!this.target;
    }

    created() {
        if (this.target) {
            const format = (<any>this).pickerDateTimeFormat;
            this.freeze = {
                StartDate: moment(this.target.StartDate).format(format),
                EndDate: moment(this.target.EndDate).format(format),
                Description: this.target.Description || '',
            };
        }
    }

    /**
     * Seciciye baglanan model ekran bicimini tutar (mixinz.pickerDateTimeFormat); kabloya cikarken
     * uygulamanin saat dilimsiz post bicimine cevrilir.
     */
    parseDisplay(display?: string | null) {
        return moment(display || '', (<any>this).pickerDateTimeFormat, true);
    }

    toWireDateTime(display: string): string {
        return dateFormat.postDateTimeFormatFromDateObject(this.parseDisplay(display).toDate()) as string;
    }

    /**
     * Yeni donem gecmiste baslayamaz. Duzenlemede tarih kilidi yok: gecmis bir donemin tarihi de
     * duzeltilebilir, sunucu yalnizca sira ve cakismayi denetler.
     */
    get startPicker() {
        const picker = (<any>this).pickerDateTime;
        return this.isUpdate ? picker : {...picker, minDate: startOfCurrentMinute()};
    }

    /** Bitis baslangictan once secilemez; baslangic secilmemisse baslangicla ayni sinir. */
    get endPicker() {
        const start = this.parseDisplay(this.freeze.StartDate);
        return start.isValid() ? {...(<any>this).pickerDateTime, minDate: start} : this.startPicker;
    }

    async onSubmit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        const formData: CFMDTOFreeze = {
            Id: this.target ? this.target.Id : 0,
            StartDate: this.toWireDateTime(<string>this.freeze.StartDate),
            EndDate: this.toWireDateTime(<string>this.freeze.EndDate),
            Description: this.freeze.Description,
        };
        blockui.blockModal(this);
        try {
            const response = this.isUpdate
                ? await this.apiClient.freeze.freezeUpdate(formData)
                : await this.apiClient.freeze.freezeStart(formData);
            if (response.data.IsSuccess) {
                toastr.success(this.translate(this.isUpdate ? 'freeze_updated_successfully' : 'freeze_started_successfully'));
                this.saveSucceeded();
                this.close();
            } else {
                toastr.error(response.data.Message ? response.data.Message : 'Error');
            }
        }
        catch (e) {
            toastr.error(e);
        }
        finally {
            blockui.unBlockModal();
        }
    }
}
